import { createContext, useContext, ReactNode, useEffect } from 'react'
import { useTrackGoogleAnalytics } from '../hooks/useTrackGoogleAnalytics'
import { initializeAnalytics } from '../helpers/analytics'
import { useAppSelector } from '../state/hooks'
import { Platform } from 'react-native'
import { detectBot } from '../utils/botDetection'

const AnalyticsContext = createContext(null)

interface AnalyticsProviderProps {
	children: ReactNode
	metaPixelId?: string
	googleAnalyticsId?: string
}

export const GoogleAnalyticsProvider = ({ children }: AnalyticsProviderProps) => {
	const analytics = useTrackGoogleAnalytics()
	const { loadedData } = useAppSelector(state => state.data)
	const metaPixelId = loadedData[global.org]?.metaPlatforms?.pixelId
	const googleAnalyticsId = loadedData[global.org]?.googleAnalytics?.measurementId
	const isBot = detectBot()

	useEffect(() => {
		if (Platform.OS === 'web' && (metaPixelId || googleAnalyticsId) && !isBot) {
			initializeAnalytics(metaPixelId, googleAnalyticsId)
		}
	}, [metaPixelId, googleAnalyticsId])

	return <AnalyticsContext.Provider value={analytics}>{children}</AnalyticsContext.Provider>
}

export const useGoogleAnalyticsContext = () => {
	const context = useContext(AnalyticsContext)
	if (!context) {
		throw new Error('useAnalyticsContext must be used within AnalyticsProvider')
	}
	return context
}
